import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'
import { escposBinaryPayload } from './escposEncoding'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  search(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "reports/search/reference" + Session.getToken();
    return instance.post(url,params);
  },
  generate(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "reports/generate/pdf" + Session.getToken();
    return instance.post(url,params);
  },
  generateEscpos(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports/generate/escpos" + Session.getToken();
    return instance.post(url,params);
  },
  generateEscposJson(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports/generate/escpos-json" + Session.getToken();
    return instance.post(url,params);
  },
  generateEscposLocal(data) {
    var params = data
    var url = ConfigAPI.baseURL + "reports/generate/escpos-local" + Session.getToken();
    return instance.post(url,params);
  },
  obtenerStaffThermalPrinter() {
    var url = ConfigAPI.baseURL + "staff/thermal-printer" + Session.getToken();
    return instance.get(url);
  },
  printEscpos(url, data, rawPayload, printerName = '', addPrinterToPayload = true) {
    let endpoint = url

    if(addPrinterToPayload && printerName) {
      endpoint += (endpoint.indexOf('?') === -1 ? '?' : '&') + 'printer=' + encodeURIComponent(printerName)
    }

    // OJO: acá se usa axios directo (no "instance"). "instance" sale de
    // axios.create(), que handler/axiosAuthInterceptor.js parchea para
    // agregarle el Authorization Bearer de la sesión a TODAS las instancias
    // del proyecto. Esta llamada no va a nuestra API: va al agente local o a
    // una URL de un servicio de terceros configurada por el usuario, así que
    // no correspondía mandarle nuestro token interno.
    if(rawPayload) {
      return axios.post(endpoint,escposBinaryPayload(data),{
        headers: {
          'Content-Type': 'text/plain',
        }
      });
    }

    if(addPrinterToPayload && data && typeof data === 'object') {
      data.printer = printerName
    }

    return axios.post(endpoint,data);
  },
}

export default servicesAPI;
